import { render, staticRenderFns } from "./GameDocument.vue?vue&type=template&id=512fd168"
import script from "./GameDocument.vue?vue&type=script&lang=js"
export * from "./GameDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports